import { useQuery } from "@tanstack/react-query";
import { supabaseAgency } from "@/lib/supabase";

export type EmailPriority = "needs_reply" | "client";

export interface ActionEmail {
  message_id: string;
  thread_id: string;
  sender: string;
  subject: string;
  snippet: string | null;
  received_at: string;
  gmail_url: string;
  linked_task_id: string | null;
  priority: EmailPriority;
  synced_at: string;
}

export function useActionEmails() {
  return useQuery({
    queryKey: ["action_emails"],
    queryFn: async () => {
      const { data, error } = await supabaseAgency
        .from("os_action_emails_cache").select("*")
        // needs_reply (a) sorts before client (c); fresh first within each group
        .order("priority", { ascending: true })
        .order("received_at", { ascending: false })
        .limit(12);
      if (error) throw error;
      const rows = (data ?? []) as ActionEmail[];
      return { rows, synced_at: rows[0]?.synced_at ?? null };
    },
  });
}
